import type {ReactElement} from 'react';
import React from 'react';
import type {SuggestionListItemProps} from '@Components/input-suggestions-dropdown/suggestion-list-item/suggestion-list-item.types';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize} from '@Components/text';
import {IconSize} from '@Components/icon-v2/icon.types';
import {ClickableDiv} from '@Components/clickable-div';
import {noop} from '@Utils/general.util';
import styles from './suggestion-list-item.module.scss';

export function SuggestionListItem({
  primaryText,
  primaryIcon = '',
  secondaryText = '',
  secondaryIcon = '',
  className = '',
  onClick = noop,
  primaryTextValue = '',
  truncatePrimaryText = false,
  showSuggestionAsTitleOnHover = false,
}: SuggestionListItemProps): ReactElement<any> {
  const onListItemClick = (): void => {
    if (primaryTextValue) {
      onClick(primaryTextValue);
    } else {
      onClick(primaryText);
    }
  };

  const getPrimaryTextContainerClass = (): string => {
    if (!secondaryText && !secondaryIcon) {
      return '_full-width';
    }
    return styles.truncatedDiv;
  };

  return (
    <ClickableDiv
      className={`_full-width flex-row-align-center spacing-p-r-3 spacing-p-l-3 radius-4 ${className} ${styles.listItemContainer}`}
      onClick={onListItemClick}
      {...(showSuggestionAsTitleOnHover && {title: primaryText})}
    >
      <div className={`${getPrimaryTextContainerClass()} flex-row-align-center `}>
        {primaryIcon ? <Icon icon={primaryIcon} size={IconSize.SIZE_ICON_16} className={`${styles.icon} content-body`} /> : null}
        <Text val={primaryText} size={TextSize.XSMALL} className={`${truncatePrimaryText ? styles.truncatedText : ''} -truncated-text content-body`} />
      </div>
      {secondaryText ? <div className={`bg-neutral-18 radius-round content-disabled spacing-m-r-2 spacing-m-l-2 ${styles.circle}`} /> : null}
      <div className="flex-row-align-center">
        {secondaryIcon ? <Icon icon={secondaryIcon} size={IconSize.SIZE_ICON_16} className={`content-disabled ${styles.icon}`} /> : null}
        {secondaryText ? <Text val={secondaryText} size={TextSize.XSMALL} className={`${styles.truncatedText} -truncated-text content-disabled`} /> : null}
      </div>
    </ClickableDiv>
  );
}
